export const getManagementType = () => process.env.REACT_APP_MANAGEMENT_TYPE;
